export const AudioDeviceSettingsTestIds = {
  DEVICE_SELECT: 'audio-settings.device-select',
  GREETING_SELECT: 'audio-settings.greeting-select',
  GRANT_ACCESS: 'audio-settings.grant-access-button',
  TOAST_CLOSE: 'audio-settings.toast-close-button',
  BACK: 'audio-settings.back-button',
  TEST_SPEAKER: 'audio-settings.test-speaker-button',
  TEST_MIC: 'audio-settings.test-mic-button',
};
